// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_6z-4";
export var collapsed = "_6z-1";
export var headerBar = "_6z-0";
export var leftHeaderContent = "_6z-3";
export var subjectContainer = "_6z-2";